/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import moment from "moment"

// prop-types is a library for typechecking of props
import PropTypes from "prop-types"

// Material Dashboard 2 React components
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"

// Material Dashboard 2 React context
import { useMaterialUIController } from "context"
import MDBadge from "components/MDBadge"
import switchStatusColor from "utils/functions/switchStatusColor"
import { translateStatus, translateAccountName } from "utils/translate/status"

function PackageItem({
  details: {
    clientName,
    reference,
    packagePrice,
    unitPrice,
    hasMultipleItems,
    deliveryFee,
    description,
    comments,
    exchange,
    status,
    isMissing,
    state,
    city,
    address,
    clientPhoneNumber,
    createdAt,
    updatedAt,
    companyName,
    barcode,
    owner,
    lazajellaType,
    productQuantity,
  },
  noGutter,
}) {
  const [controller] = useMaterialUIController()
  const { darkMode } = controller

  return (
    <MDBox
      component="li"
      display="flex"
      justifyContent="space-between"
      alignItems="flex-start"
      bgColor={darkMode ? "transparent" : "grey-100"}
      borderRadius="lg"
      p={3}
      mb={noGutter ? 0 : 1}
      mt={2}
    >
      <MDBox width="100%" display="flex" flexDirection="column">
        <MDBox
          display="flex"
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
          flexDirection={{ xs: "column", sm: "row" }}
          mb={2}
        >
          <MDTypography color="info" variant="h4" fontWeight="medium" textTransform="capitalize">
            {clientName || "N/A"}
          </MDTypography>
        </MDBox>
        <MDBox mb={1} lineHeight={0}>
          <MDTypography variant="body2" color="text">
            Référence:&nbsp;&nbsp;&nbsp;
            <MDTypography variant="p" fontWeight="medium">
              #{reference || "N/A"}
            </MDTypography>
          </MDTypography>
        </MDBox>
        <MDBox mb={1} lineHeight={0}>
          <MDTypography variant="body2" color="text">
            Code à barre:&nbsp;&nbsp;&nbsp;
            <MDTypography variant="p" fontWeight="medium">
              {barcode || "N/A"}
            </MDTypography>
          </MDTypography>
        </MDBox>
        <MDBox mb={1} lineHeight={0}>
          <MDTypography variant="body2" color="text">
            Compte courant:&nbsp;&nbsp;&nbsp;
            <MDTypography variant="p" fontWeight="medium">
              {translateAccountName(owner) || "N/A"}
            </MDTypography>
          </MDTypography>
        </MDBox>
        <MDBox mb={1} lineHeight={0}>
          <MDTypography variant="body2" color="text">
            Entreprise:&nbsp;&nbsp;&nbsp;
            <MDTypography variant="p" fontWeight="medium" textTransform="capitalize">
              {companyName || "N/A"}
            </MDTypography>
          </MDTypography>
        </MDBox>
        <MDBox mb={1} lineHeight={0}>
          <MDTypography variant="body2" color="text">
            Type:&nbsp;&nbsp;&nbsp;
            <MDTypography variant="p" fontWeight="medium" textTransform="capitalize">
              {companyName === "lazajella" ? lazajellaType : "N/A" || "N/A"}
            </MDTypography>
          </MDTypography>
        </MDBox>
        <MDBox mb={1} lineHeight={0}>
          <MDTypography variant="body2" color="text">
            Prix:&nbsp;&nbsp;&nbsp;
            <MDTypography variant="p" fontWeight="medium">
              {(packagePrice || 0).toFixed(2) || "N/A"} TND
            </MDTypography>
          </MDTypography>
        </MDBox>
        <MDBox mb={1} lineHeight={0}>
          <MDTypography variant="body2" color="text">
            Prix unitaire:&nbsp;&nbsp;&nbsp;
            <MDTypography variant="p" fontWeight="medium">
              {unitPrice ? unitPrice.toFixed(2) + " TND" : hasMultipleItems ? "Divers produits" : "N/A"}
            </MDTypography>
          </MDTypography>
        </MDBox>
        <MDBox mb={1} lineHeight={0}>
          <MDTypography variant="body2" color="text">
            Frais de livraison:&nbsp;&nbsp;&nbsp;
            <MDTypography variant="p" fontWeight="medium">
              {(deliveryFee || 0).toFixed(2)} TND
            </MDTypography>
          </MDTypography>
        </MDBox>
        <MDBox mb={1} lineHeight={0}>
          <MDTypography variant="body2" color="text">
            Quantité:&nbsp;&nbsp;&nbsp;
            <MDTypography variant="p" fontWeight="medium">
              {productQuantity || "N/A"}
            </MDTypography>
          </MDTypography>
        </MDBox>
        <MDBox mb={1} lineHeight={0}>
          <MDTypography variant="body2" color="text">
            Téléphone:&nbsp;&nbsp;&nbsp;
            <MDTypography variant="p" fontWeight="medium">
              {clientPhoneNumber || "N/A"}
            </MDTypography>
          </MDTypography>
        </MDBox>
        <MDBox mb={1} lineHeight={0}>
          <MDTypography variant="body2" color="text">
            État:&nbsp;&nbsp;&nbsp;
            <MDTypography variant="p" fontWeight="medium">
              {state || "N/A"}
            </MDTypography>
          </MDTypography>
        </MDBox>
        <MDBox mb={1} lineHeight={0}>
          <MDTypography variant="body2" color="text">
            Ville:&nbsp;&nbsp;&nbsp;
            <MDTypography variant="p" fontWeight="medium">
              {city || "N/A"}
            </MDTypography>
          </MDTypography>
        </MDBox>
        <MDBox mb={1} lineHeight={0}>
          <MDTypography variant="body2" color="text">
            Adresse:&nbsp;&nbsp;&nbsp;
            <MDTypography variant="p" fontWeight="medium">
              {address || "N/A"}
            </MDTypography>
          </MDTypography>
        </MDBox>
        <MDBox mb={1} lineHeight={0}>
          <MDTypography variant="body2" color="text">
            Description:&nbsp;&nbsp;&nbsp;
            <MDTypography variant="p" fontWeight="medium">
              {description || "N/A"}
            </MDTypography>
          </MDTypography>
        </MDBox>
        <MDBox mb={1} lineHeight={0}>
          <MDTypography variant="body2" color="text">
            Commentaires:&nbsp;&nbsp;&nbsp;
            <MDTypography variant="p" fontWeight="medium">
              {comments || "N/A"}
            </MDTypography>
          </MDTypography>
        </MDBox>
        <MDBox mb={1} lineHeight={0}>
          <MDTypography variant="body2" color="text">
            Statut:&nbsp;&nbsp;&nbsp;
            <MDTypography variant="p" fontWeight="medium">
              <MDBadge
                badgeContent={translateStatus(status)}
                color={switchStatusColor(status)}
                variant="gradient"
                size="lg"
              />
            </MDTypography>
          </MDTypography>
        </MDBox>
        <MDBox mb={1} lineHeight={0}>
          <MDTypography variant="body2" color="text">
            Manquant:&nbsp;&nbsp;&nbsp;
            <MDTypography variant="p" fontWeight="medium">
              <MDBadge
                badgeContent={isMissing ? "oui" : "non"}
                color={isMissing ? "success" : "error"}
                variant="gradient"
                size="lg"
              />
            </MDTypography>
          </MDTypography>
        </MDBox>
        <MDBox mb={1} lineHeight={0}>
          <MDTypography variant="body2" color="text">
            Échange:&nbsp;&nbsp;&nbsp;
            <MDTypography variant="p" fontWeight="medium">
              <MDBadge
                badgeContent={exchange ? "oui" : "non"}
                color={exchange ? "success" : "error"}
                variant="gradient"
                size="lg"
              />
            </MDTypography>
          </MDTypography>
        </MDBox>
        <MDBox mb={1} lineHeight={0}>
          <MDTypography variant="body2" color="text">
            Date de mise à jour du statut:&nbsp;&nbsp;&nbsp;
            <MDTypography variant="p" fontWeight="medium">
              {moment(updatedAt).format("MMM DD, YYYY") || "N/A"}
            </MDTypography>
          </MDTypography>
        </MDBox>
        <MDTypography variant="body2" color="text">
          Date de création:&nbsp;&nbsp;&nbsp;
          <MDTypography variant="p" fontWeight="medium">
            {moment(createdAt).format("MMM DD, YYYY") || "N/A"}
          </MDTypography>
        </MDTypography>
      </MDBox>
    </MDBox>
  )
}

// Setting default values for the props of PackageItem
PackageItem.defaultProps = {
  details: {},
  noGutter: false,
}

// Typechecking props for the PackageItem
PackageItem.propTypes = {
  details: PropTypes.shape({
    clientName: PropTypes.string,
    reference: PropTypes.number,
    packagePrice: PropTypes.number,
    unitPrice: PropTypes.number,
    hasMultipleItems: PropTypes.bool,
    deliveryFee: PropTypes.number,
    description: PropTypes.string,
    productQuantity: PropTypes.number,
    comments: PropTypes.string,
    exchange: PropTypes.number,
    status: PropTypes.string,
    isMissing: PropTypes.number,
    state: PropTypes.string,
    city: PropTypes.string,
    address: PropTypes.string,
    clientPhoneNumber: PropTypes.string,
    createdAt: PropTypes.string,
    updatedAt: PropTypes.string,
    companyName: PropTypes.string,
    barcode: PropTypes.string,
    owner: PropTypes.string,
    lazajellaType: PropTypes.string,
  }),
  noGutter: PropTypes.bool,
}

export default PackageItem
